import SwiperCore, { Navigation, Autoplay, EffectFade } from 'swiper/core';
SwiperCore.use([Navigation, Autoplay, EffectFade]);
import Swiper from 'swiper';

(function($) {
  $(function() {
    $('.number-slider__swiper').each(function() {
      var $slider = $(this);

      var swiper = new Swiper($slider.get(0), {
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        speed: 700
      });
    });
  });
})(jQuery);
